





































import {Component, Prop} from 'vue-property-decorator';
import CompanyMixin from '@/mixins/CompanyMixin';
import DocumentSharing from '@/components/DocumentSharing.vue';

@Component({
  components: {DocumentSharing},
})
export default class MetaIndustryAnalysis extends CompanyMixin {
  @Prop() readonly doc!: any;
}
